<template>
<div>
  <div
    v-show="!loading && selectedDate && opcionais.length > 0"
    :style="styleWrapper"
    class="wrapper">
    <div
      v-if="!mobileMode"
      class="header-container">
      <div style="width: 9%; text-align: center;">
        <i
          :style="{'color': primaryColor}"
          style="font-size: 20px;"
          class="fa-solid fa-star" />
      </div>
      <div style="width: 90%; font-size: 14px; line-height: 18px;">
        <div><strong>Melhore sua experiência</strong></div>
        <span>com nossos opcionais</span>
      </div>
    </div>
    <div
      v-for="(opt, i) in opcionais"
      :key="opt.id"
      :style="{border: i == 0 ? 'none' : null}"
      :class="{
        'option': !mobileMode,
        'option-mobile': mobileMode
      }">
      <div
        class="option-info"
        :style="{'width': mobileMode ? '64%' : null}">
        <strong>{{ opt.nome }}</strong><br>
        <span>{{ formatMoney(opt.preco) }}</span>
      </div>
      <div
        class="option-quantity"
        :style="{'width': mobileMode ? '25%' : null}">
        <i
          class="fa-solid fa-minus"
          style="cursor: pointer;"
          @click="sub(opt)" />
        <div class="option-quantity-display">
          <strong>{{ getCurrentQuantidade(opt) }}</strong>
        </div>
        <i
          class="fa-solid fa-plus"
          style="cursor: pointer;"
          @click="add(opt)" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';

const dateToString = function(date) {
    const mes = date.toLocaleDateString('pt-BR', { month: '2-digit' });
    const dia = date.toLocaleDateString('pt-BR', { day: '2-digit' });
    const ano = date.toLocaleDateString('pt-BR', { year: 'numeric' });
    return ano + '-' + mes + '-' + dia;
};

export default {
    components: {},
    props: {
        value: {
            type: Array,
            default: () => [],
            required: false
        },
        selectedDate: {
            validator: (v) => v instanceof Date || v == null,
            default: () => null,
            required: true
        },
        max: {
            type: Number,
            default: () => 0,
            required: true
        },
        primaryColor: {
            type: String,
            default: () => '#FF0000',
            required: true
        },
        passeioId: {
            type: [Number, String],
            default: () => 0,
            required: true
        },
        mobileMode: {
            type: Boolean,
            default: () => false,
            required: false
        },
        moeda: {
            type: String,
            default: () => 'BRL',
            required: true
        }
    },
    emits: ['input', 'optionals-loaded', 'optionals-availability-change', 'is-loading'],
    data() {
        return {
            loading: false,
            opcionais: []
        };
    },
    computed: {
        styleWrapper() {
            if(this.$props.mobileMode) {
                return {
                    'margin-left': '-30px',
                    'margin-right': '-30px',
                    'border-radius': '0px',
                    'padding': '0px',
                    'border-top': '1px solid ' + this.$props.primaryColor,
                    'border-bottom': '1px solid ' + this.$props.primaryColor,
                    'background': `transparent linear-gradient(124deg, #FFFFFF 0%, ${this.$props.primaryColor} 1000%) 0% 0% no-repeat padding-box`,
                };
            }
            return {
                'border': '1px solid ' + this.$props.primaryColor,
                'background': `transparent linear-gradient(124deg, #FFFFFF 0%, ${this.$props.primaryColor} 1000%) 0% 0% no-repeat padding-box`,
            };
        }
    },
    watch: {
        selectedDate() {
            this.loadOpcionais();
        },
        max() {
            this.removeOptionalsUntilMax(this.$props.max);
        },
        opcionais() {
            this.$emit('optionals-availability-change', this.opcionais.length > 0);
        },
        loading() {
            this.$emit('is-loading', this.loading);
        }
    },
    methods: {
        sub(opt) {
            this.mudarQuantidade(opt, -1);
        },
        add(opt) {
            this.mudarQuantidade(opt, 1);
        },
        mudarQuantidade(opt, quantidade) {
            if(quantidade > this.$props.max) {
                return false;
            }
            const current = JSON.parse(JSON.stringify(this.$props.value));
            for (let i = 0; i < current.length; i++) {
                const optAtual = current[i];
                if(optAtual.id == opt.id) {
                    optAtual.quantidade += quantidade;
                    if(optAtual.quantidade < 0 || optAtual.quantidade > this.$props.max) {
                        return false;
                    }
                    this.$emit('input', current.filter(op => op.quantidade > 0));
                    return true;
                }
            }
            if(quantidade < 0) {
                return false;
            }
            current.push({
                'id': opt.id,
                'opcional_id': opt.opcional_id,
                'nome': opt.nome,
                'quantidade': quantidade,
                'preco': opt.preco,
            });

            this.$emit('input', current.filter(op => op.quantidade > 0));
            return true;
        },
        getCurrentQuantidade(opt) {
            for (let i = 0; i < this.$props.value.length; i++) {
                const optAdicionado = this.$props.value[i];
                if(optAdicionado.id == opt.id) {
                    return optAdicionado.quantidade;
                }
            }
            return 0;
        },
        async loadOpcionais() {
            if(this.$props.selectedDate == null) {
                return;
            }
            this.loading = true;
            try {
                const uri = '?data=' + dateToString(this.$props.selectedDate);
                const r = (await axios.get('/opcionais_disponiveis/' + this.$props.passeioId + uri)).data;
                if(!r.success) {
                    this.opcionais = [];
                    return;
                }
                this.opcionais = Object.values(r.itens);
            } catch(err) {
                this.opcionais = [];
            } finally {
                this.loading = false;
                this.$emit('optionals-loaded');
            }
        },
        removeOptionalsUntilMax(max) {
            if(max <= 0) {
                this.$emit('input', []);
                return;
            }
            const copy = JSON.parse(JSON.stringify(this.$props.value));
            for(let i = 0; i < copy.length; i++) {
                if(copy[i].quantidade > max) {
                    copy[i].quantidade = max;
                }
            }

            this.$emit('input', copy);
        },
        formatMoney(price) {
            let locale = 'pt-Br';

            if (this.$props.moeda === 'USD') {
                locale = 'en-US';
            }

            if(price <= 0 || price === null) {
                return 'Gratuito';
            }
            return Number(price).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
        },
    }
};
</script>

<style scoped>
.wrapper {
    margin-left: -20px;
    margin-right: -20px;
    padding: 20px;
    border-radius: 12px;
}

.option {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.option-mobile {
    border-top: 1px solid #CBCBCB; 
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
}

.option-info {
    line-height: 18px;
    font-size: 14px;
    width: 79%;
}

.option-quantity {
    width: 20%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.option-quantity-display {
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    color: #464646;
    background-color: transparent;
}

.header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
</style>
